import { Link } from "react-router-dom";

/** The two links every footer carries. One component so the paths and the
 *  words cannot drift between the landing page, the sidebar and the forms. */
export const TERMS_PATH = "/taisykles";
export const PRIVACY_PATH = "/privatumas";

export function LegalLinks({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-4 gap-y-1 ${className}`}>
      <Link to={TERMS_PATH} className="underline underline-offset-4">
        Taisyklės
      </Link>
      <Link to={PRIVACY_PATH} className="underline underline-offset-4">
        Privatumo politika
      </Link>
    </span>
  );
}
